import { render, staticRenderFns } from "./BulkAddDepartmentModal.vue?vue&type=template&id=0a65c1c6"
import script from "./BulkAddDepartmentModal.vue?vue&type=script&lang=js"
export * from "./BulkAddDepartmentModal.vue?vue&type=script&lang=js"
import style0 from "./BulkAddDepartmentModal.vue?vue&type=style&index=0&id=0a65c1c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports